import './markerDetailStopLineCard.scss';
import React, { useState, useRef, useEffect, useMemo, Fragment } from 'react';
import { set } from 'redux/slices/plannerSegmentsSlice';
import styled from 'styled-components';
import Button from 'components/commons/buttons/button/Button';
import { Popup } from 'react-leaflet';
import { ReactComponent as Ic_Star } from 'resources/icons/Ic_Star.svg';
import { ReactComponent as Ic_Star_white } from 'resources/icons/Ic_Star_white.svg';
import { ReactComponent as Ic_Nav } from 'resources/icons/Ic_Navigation.svg';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { RUTAS_GENERALES_MUL2, POI_DEFAULT_BACKGROUND } from 'utils/constants';
import ModalDelete from 'components/commons/modal/modalDelete/ModalDelete';
import UseSEO from 'hooks/useSEO/UseSEO';
import { useLanguage, useTranslate } from 'context/languageContext';
import SvgIcon from 'components/commons/icons/SvgIcon';
import { ReactComponent as Ic_Arrow_Right } from 'resources/icons/Ic_Arrow_Right.svg';
import IconPromise from 'components/widgets/IconPromise/IconPromise';
import { useSelector } from 'react-redux';
import { transportModeState } from 'redux/slices/transportmodeSlice';
import { useFavorites } from 'hooks/useFavorites/useFavorites';
import SaveFavoriteModal from 'screens/favoritesScreen/components/modals/saveFavoriteMoodal/SaveFavoriteModal';
import { stopsFavoritesState } from 'redux/slices/favoritesSlice';

interface IMarker {
  marker: any;
  onClose?:()=>void
}

export default function  MarkerDetailStopLineCard({ marker, onClose }:IMarker) {
  const currentLanguage = useLanguage();
  const favoriteStopsSelector = useSelector(stopsFavoritesState);
  const BACKGROUND = marker?.data?.iconPoiCategory?.color || POI_DEFAULT_BACKGROUND;
  const { deleteFavorites, saveFavorites, isFavorite } = useFavorites();
  const popupRef = useRef<any>();
  const StyledPopup = styled(Popup)`
    .leaflet-popup-content-wrapper {
      background: ${BACKGROUND}!important;
    }
    .leaflet-popup-content-wrapper,
    .leaflet-popup-tip {
      background: ${BACKGROUND}!important;
    }
  `;

  const t = useTranslate();
  const [showDelete, setShowDelete] = useState(false);
  const [showFavorite, setShowFavorite] = useState(false);
  const [stopData, setStopData] = useState({ ...marker });
  const [isFav, setIsFav] = useState<any>(isFavorite('stops', marker?.id));

  const navigate = useNavigate();
  const [generateUrl] = UseSEO();
  const dispatch = useDispatch();

  const onClickNaV = (desde=false) => {
    const fMarker= marker ? {...marker, name:marker?.data?.name}: null;
    dispatch(set({ index: desde ? 0 : 1 , overwrite: true, stop: fMarker }));
    dispatch(set({ index: desde ? 1 : 0, overwrite: true, stop: null }));
    const segments = desde ? [fMarker,null]:[null,fMarker];
    setTimeout(() => {
      navigate(generateUrl(RUTAS_GENERALES_MUL2.planner, 'PLAN', segments));
    }, 300);
  };
  const selectorTransportModes = useSelector(transportModeState);

  const getTransportModeIcon = () => {
    const iconId = selectorTransportModes?.find(
      (transporte) => Number(transporte.id) === Number(1),
    )?.iconId;
    return iconId;
  };

  const handleFavorite = ()=>{
    if(/* isFavorite('stops', marker.id) */isFav) setShowDelete(true);
    else setShowFavorite(true);
  };

    // Manejar el cierre del popup manualmente
    const handleManualClose = () => {
      if (popupRef.current) {
        popupRef.current.remove(); // Cierra el popup usando la referencia de Leaflet
        onClose && onClose();
      }
    };

  useEffect(()=>{
    setIsFav(isFavorite('stops', marker?.id));
  },[favoriteStopsSelector]);

  const myPopUp = useMemo(() => {
    return (
      <>
      <StyledPopup
        className='contact-marker-popup'
        closeButton={false} // Desactiva el botón de cierre por defecto
        autoClose={false}
        closeOnClick={false}
        ref={popupRef} // Asigna la referencia al popup
        >
        <div className='popup-btn-close' onClick={handleManualClose}>
          x
        </div>
        <div
          className='detail-marker-card'
          id={`emt-marker-card-${marker?.id}`}
          onClick={(e) => {
            // popupRef?.current && popupRef?.current?.onClick();
          }}
          style={{ background: BACKGROUND }}
        >
          <div className='icon-box'>
            <IconPromise idIcon={getTransportModeIcon()} />
          </div>
          <div className='info-box'>
            <h3>{`${marker?.id} - ${marker?.data.name}`}</h3>

            <span
              className='inline-content'
              onClick={() => {
                marker?.data.onclickPasoPorParada();
              }}
            >
              <SvgIcon Icon={Ic_Arrow_Right} color='white' />
              <p>{t('lb_paso_por_parada')}</p>
            </span>
            <span className='inline-content'>
              <SvgIcon Icon={Ic_Arrow_Right} color='white' onClick={() => onClickNaV(true)} />
              <p onClick={() => onClickNaV(true)}>{t('lb_ruta_desde_esta_parada')}</p>
            </span>
            <span
              className='inline-content'
              onClick={() => navigate(`${RUTAS_GENERALES_MUL2.notices[currentLanguage]}`)}
            >
              <SvgIcon Icon={Ic_Arrow_Right} color='white' />
              <p>{t('lb_avisos')}</p>
            </span>
          </div>
          <div className='popup-actions-box'>
            <Button
              icon={Ic_Nav}
              className='btn-nav'
              height='38px'
              width='38px'
              onClick={() => onClickNaV()}
            />
            <Button
              icon={isFav ? Ic_Star: Ic_Star_white}
              height='38px'
              width='38px'
              className='btn-fav'
              background={isFav ? '#FFFFFF': BACKGROUND}
              style={{ border: 'solid 2.5px white' }}
              onClick={() => handleFavorite()}
            />
          </div>
        </div>
      </StyledPopup>
    </>
    );
  },[favoriteStopsSelector]);

  return (
    <>
      {myPopUp}
      {showDelete && (
        <ModalDelete
          onClose={() => setShowDelete(false)}
          title={`¿${t('lb_favorites_seguro_eliminar_parada')} "${marker?.data.name}"?`}
          onAccept={() => {
            deleteFavorites('stops', [marker?.id], () => setShowDelete(false));
          }}
        />
      )}
      {showFavorite && (
        <SaveFavoriteModal
          onClose={() => setShowFavorite(false)}
          title={t('lb_favorites_guardar_parada_interrogante')}
          markerType={'stops'}
          text={t('lb_favorites_guardar_parada_main')}
          secondaryText={t('lb_favorites_guardar_secondary')}
          onAccept={() => {
            saveFavorites('stops', [stopData], () => setShowFavorite(false));
          }}
          onAliasChange={(a) => setStopData(a)}
          onIconChange={(a) => setStopData(a)}
          item={stopData}
        />
      )}
    </>
  );
};
